/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageRoute: "report",
};

export const RouteSlice = createSlice({
  name: "pageNow",
  initialState: initialState,
  reducers: {
    savePageRoute: (state, action) => {
      state.pageRoute = action.payload === "track" ? "follow" : action.payload;
    },
  },
});

export const { savePageRoute } = RouteSlice.actions;
export default RouteSlice.reducer;
